/**
 * Header component with branding and title
 */

export function Header() {
  return (
    <header className="bg-gradient-to-r from-slate-900 to-slate-800 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-4xl font-bold tracking-tight">
              🔍 HIVE CrossCheck
            </h1>
            <p className="text-slate-300 mt-2">
              Multi-chain author activity analysis (HIVE • Steemit • Blurt)
            </p>
          </div>
          <div className="text-right text-sm text-slate-400">
            <p>Last updated: <span className="text-white font-mono">{new Date().toLocaleTimeString()}</span></p>
          </div>
        </div>
      </div>
    </header>
  );
}
